import { useRef, useState } from "react";

import { TimeList } from "@/components/form/TimeList";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { MinuteStep, time } from "@/lib/time";

export const TimePicker = ({
  value,
  onChange,
  minuteStep = 5,
}: {
  value: string;
  onChange: (next: string) => void;
  minuteStep?: MinuteStep;
}) => {
  const [open, setOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSelect = (next: string) => {
    onChange(next);
    setOpen(false);
  };

  const render = () => (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger className="flex h-9 w-[108px] shrink-0 items-center justify-center rounded-md bg-lever-surface-neutral text-sm tabular-nums text-lever-text-heading ring-offset-white focus:outline-none focus-visible:ring-1 focus-visible:ring-lever-border-information">
        {value ? time.formatLabel(value) : "Select"}
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-48 p-0"
        onOpenAutoFocus={(e) => {
          e.preventDefault();
          inputRef.current?.focus();
        }}
      >
        <TimeList
          value={value}
          onSelect={handleSelect}
          minuteStep={minuteStep}
          inputRef={inputRef}
        />
      </PopoverContent>
    </Popover>
  );

  return render();
};
